import * as React from 'react';
import { useSelector } from 'react-redux';

import { StickyFooter } from '../../components/StickyFooter';
import { selectIsStickyFooterVisible } from '../../selectors/page';
import { ValuationFormModalOpenerContainer } from '../ValuationFormModalOpenerContainer';

export const StickyFooterContainer: React.FC = () => {
  const isStickyFooterVisible = useSelector(selectIsStickyFooterVisible);

  if (!isStickyFooterVisible) {
    return null;
  }

  return (
    <StickyFooter>
      <ValuationFormModalOpenerContainer inStickyFooter />
    </StickyFooter>
  );
};
